import { useCallback } from 'react';

import { getAppByQreIdImportDatabases } from '../api/generated-evs';

export type ImportDatabasesResult = Record<string, { name: string; enabled: boolean }>;

export function useImportDatabases(qreId: string): () => Promise<ImportDatabasesResult> {
  return useCallback(async (): Promise<ImportDatabasesResult> => {
    try {
      const { data } = await getAppByQreIdImportDatabases({ path: { qreId }, throwOnError: true });
      return data || {};
    } catch (error) {
      console.error('Error fetching import databases:', error);
      return {};
    }
  }, [qreId]);
}
